<template>
  <div class="fs-adjustments">
    <fs-range-filter-wrapper :routerLink="'/adjustments'" min="-2" max="2" defaultValue="0" v-model="value.rotation" label="menu.hue"/>
  </div>
</template>

<script lang="ts">
import { Adjustments } from '@filestack/canvas-sdk';
import { Component } from 'vue-property-decorator';
import { FilterMixin } from './FilterMixin';

@Component
class Hue extends FilterMixin {

  protected value = { rotation: 0 };

  protected filter = new Adjustments.Hue();

}

export default Hue;
</script>
